import { createRouter, createWebHashHistory } from 'vue-router';
import ChooseUserConfigurableForm from '../views/ChooseUserConfigurableForm.vue';
import ConfigurableForm from '../views/ConfigurableForm.vue';
import Login from '../views/Login.vue';
import Register from '../views/Register.vue';
import Home from '../views/Home.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
    },
    {
        name: "ChooseUserConfigurableForm",
        path: "/ChooseUserConfigurableForm/:form_id",
        component: ChooseUserConfigurableForm,
        props: (route) => {
            return { ...route.params };
        },
    },
    {
        name: "ConfigurableForm",
        path: "/ConfigurableForm/:form_id",
        component: ConfigurableForm,
        props: (route) => {
            return { ...route.params };
        },
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;